import React from 'react';
import './CustomTab.css';

interface TabsI {
    tabs: TabI[];
    selected: number;
    onSelect: (newTabKey: any) => void;
    children?: React.ReactNode;
}

interface TabI {
    id: string;
    content: string;
    isDisabled?: boolean;
}
interface ClassesI {
    [className: string]: any;
}

export const CustomTabs = (props: TabsI) => {
    const { tabs, selected, onSelect, children } = props;
    return (
        <div className="custom-tabs__wrapper">
            <div className="custom-tabs__container">
                <ul
                    aria-label="tablist"
                    className="custom-tabs custom-tabs-filled">
                    {tabs.map((item, index) => {
                        return (
                            <li
                                id={item?.id ?? ''}
                                role="none"
                                key={item.id}
                                className={classnames({
                                    'custom-tabs__item': true,
                                    'custom-tabs__item--active':
                                        selected === index,
                                })}
                                onClick={() => {
                                    if (selected === index || item?.isDisabled)
                                        return;
                                    onSelect(index);
                                }}>
                                <div className="custom-tabs__body">
                                    <span className="custom-tabs__title">
                                        {item.content}
                                    </span>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
            {children && (
                <div
                    className="custom-tabs__contentBox"
                    role="tabpanel"
                    aria-labelledby={`tab-${selected}`}>
                    {children}
                </div>
            )}
        </div>
    );
};

export const classnames = (classes: ClassesI) => {
    return Object.keys(classes)
        .filter((className) => classes[className])
        .join(' ');
};
